import React from 'react';
import { Icon } from '@frontend/icons';
import { styles } from '../../../styles';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';

type BoldActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const BoldAction = ({ compact = true, showBoxShadow = true, ...rest }: BoldActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' css={styles.flexCenter}>
        <Icon name='bold-small' />
      </Text>
    </ActionPressedChip>
  );
};
